import type { Dispatch, MutableRefObject, SetStateAction } from 'react';

export interface CbullshitcodingContentStateControls {
  fadeDurationMs: number;
  fadeTimeoutRef: MutableRefObject<ReturnType<typeof setTimeout> | undefined>;
  hasContentRef: MutableRefObject<boolean>;
  resetTypingState: () => void;
  setIsFadingOut: Dispatch<SetStateAction<boolean>>;
  setLoadedStrings: Dispatch<SetStateAction<string[]>>;
  setPendingStrings: Dispatch<SetStateAction<string[] | null>>;
}

export function clearCbullshitcodingFadeTimeout(input: {
  timeoutRef: MutableRefObject<ReturnType<typeof setTimeout> | undefined>;
}): void {
  if (input.timeoutRef.current) {
    clearTimeout(input.timeoutRef.current);
  }
}

export function getCodeFileLines(input: { text: string }): string[] {
  return input.text
    .split('\n')
    .filter((line) => line.trim().length > 0);
}
